import { FunctionComponent } from 'react';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageJobSectionJobBlocksJobHeader: FunctionComponent<Props> = ({
    title,
}) => {
    return (
        <StyledComponent className="public-page-company-site-section-company-block-title">
            <p className="title">
                {title}
            </p>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobHeader;
